import applicationConstants from '~/libs/constants/application-constants.js'

/**
 * Composable to access application constants
 * @returns {Object} Application constants including routes and event options
 */
export const useApplicationConstants = () => {
  return applicationConstants
}

